<template>
    <div>
        <div class="bax-main-wrapper">
            <header>
                <div class="container">
                    <div class="d-flex">
                        <div class="bax-logo">
                            <h1>
                                <router-link to="/">
                                    <img src="@/assets/images/logo.png" alt="Baxter Compounding">
                                </router-link>
                            </h1>
                        </div>
                    </div>
                </div>
            </header>
            <main>
                <div class="bax-login-section">
                    <div class="container">
                        <div class="bax-form-wrapper">
                            <div class="bax-section-title">
                                <h1 class="d-flex align-items-center"><img src="@/assets/images/login-img.png" alt="Reset Password">Reset Password</h1>
                                <p>Enter your new password below.</p>
                            </div>
                            <form novalidate @submit.prevent="resetPassword" autocomplete="off">
                                <ul>
                                    <li>
                                        <div  class="bax-form-group" v-bind:class="{ 'bax-form-error' : $v.password.$error }">
                                            <label for="newpassword">New Password</label>
                                            <input autocomplete="off" :type="showPassword === true ? 'text' : 'password'" id="newpassword" placeholder="********" v-model="password">
                                            <a href="#" @click.prevent="togglePassword" title="Show Password"><i class="icon-show"></i></a>
                                        </div>
                                    </li>
                                    <li>
                                        <div  class="bax-form-group" v-bind:class="{ 'bax-form-error' : $v.confirmPassword.$error }">
                                            <label for="confirm-password">Confirm Password</label>
                                            <input :type="showConfirmPassword === true ? 'text' : 'password'" id="confirm-password" placeholder="********" v-model="confirmPassword">
                                            <a href="#" @click.prevent="toggleConfirmPassword" title="Show Password"><i class="icon-show"></i></a>
                                            <p v-if="$v.confirmPassword.$dirty && !$v.confirmPassword.sameAsPassword">Password does not match</p>
                                        </div>
                                    </li>
                                </ul>
                                <div class="bax-cta-block d-flex align-items-center">
                                    <input type="submit" value="Reset Password" class="bax-btn bax-btn-blue">
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { required, sameAs } from 'vuelidate/lib/validators';
import { resetPassword } from '@/services/auth.service';
import UserServie from '@/core/api/user/user.service';

export default {
    name: 'ResetPassword',
    data() {
        return {
            showPassword: false,
            showConfirmPassword: false,
            password: '',
            confirmPassword: '',
            token: '',
        };
    },
    validations: {
        password: {
            required,
        },
        confirmPassword: {
            required,
            sameAsPassword: sameAs('password'),
        },
    },
    created() {
        this.token = this.$route.query.token;
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'forgotPassword' });
        },
        togglePassword() {
            if (this.showPassword === true) {
                this.showPassword = false;
            } else {
                this.showPassword = true;
            }
        },
        toggleConfirmPassword() {
            if (this.showConfirmPassword === true) {
                this.showConfirmPassword = false;
            } else {
                this.showConfirmPassword = true;
            }
        },
        resetPassword() {
            this.$v.$touch();

            if (!this.$v.$invalid) {
                UserServie.resetForgotPassword(this.password, this.token)
                    .then(() => {
                        this.$session.flash.set('reset_password', true);
                        this.$router.push({ name: 'login' });
                    });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.bax-form-error {
    input {
        border: 1px solid red !important;
    }
}
.btn-back {
    margin-left: 20px;
}
</style>
